export const AccountConstants = {
  defaultBirthDate: new Date(1990, 0, 1), // 1990-01-01
};
